import _ from 'lodash';
import { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { SettingParentContext } from '../cnr/contexts/SettingParentContext';
import { SettingsAreaContext } from '../cnr/contexts/SettingsAreaContext';
import ViewSettingsProvider from '../cnr/contexts/ViewSettingsContext';
import { viewSettingsHandlers, viewSettingsInitialState, viewSettingsReducer } from '../cnr/reducers/ViewSettingsReducer';
import { uniqueKey } from '../common/keys';
import { appIconTypes } from '../enums/appIconTypes';
import { iconColorTypes } from '../enums/settingsIconTypes';
import Wrapper from '../wrappers/Wrapper';
import ViewSettingsSwiper from './ViewSettingsSwiper';
import MenuSettingsClose from './components/menus/MenuSettingsClose';
import SettingsMenuSubHeader from './components/menus/SettingsMenuSubHeader';
import { AppParentContext } from 'global/cnr/contexts/AppParentContext';
import { useFunctions } from 'global/cnr/contexts/useHelpers/useFunctions';

const allowUpdates = true

/**
 * /**
 * depricated  
 * @returns The main content of all of the viewSettings, nested under the ViewSettingsSidebar
 */
const ViewSettings = (props) => {

  console.log('>>> ViewSettings')

  const { ncProps } = props ?? {}

  // appParentContext
  const appParentContext = useContext(AppParentContext);
  const { fn_cls: _fn_cls } = appParentContext ?? {}

  // settingsParentContext
  const settingsParentContext = useContext(SettingParentContext)
  const { states, handlers, settings, fns } = settingsParentContext ?? {}
  const { app_state, global_state, appUser_state, paps_state, page_state, appSettings_state, currentSettings_state } = states ?? {}
  const { navigate } = handlers ?? {}
  const { homeSettings } = settings ?? {}
  const { appSettings_fns } = fns ?? {}
  const { global: global_home } = homeSettings ?? {}
  const { settingsOptions: settingsOptions_home } = global_home ?? {}
  const { mainFunctions } = app_state ?? {}

  // settingsAreaContext
  const settingsAreaContext = useContext(SettingsAreaContext)
  const { settingsArea_state, settingsArea_handlers } = settingsAreaContext ?? {}
  const { isGlobal, isSolo, selectedGroupItem, startSwipeItems, directViewItem } = settingsArea_state ?? {}
  const { handleCloseGroupItem } = settingsArea_handlers ?? {}

  const { appUser } = appUser_state ?? {}
  const { view, isMobileDevice, appArea, settingsDocName } = paps_state
  const { sandboxOn } = appSettings_state ?? {}
  const { aps_global, aps_viewItems, aps_views } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { trueView } = page_state ?? {}
  const { useDarkMode } = settingsOptions_home ?? {}

  const { fn_cls } = useFunctions()

  const settings_init = {
    gvvi: {
      global: { ...aps_global },
      viewItems: { ...aps_viewItems },
      views: { ...aps_views },
    },
    page: aps_page ? { ...aps_page } : {},
  }

  // local state
  const initState = {
    allowUpdates,
    appUser,
    isGlobal,
    isGlobalPageItem: isGlobal ? false : true,
    isMobileDevice,
    settingsParentContext,
    selectedGroupItem,
    settings_init,
    startSwipeItems,
    view,
    mainFunctions,
    fn_cls,
  }

  // reducer
  const [viewSettings_state, viewSettings_dispatch] = useReducer(viewSettingsReducer, initState, viewSettingsInitialState);
  const viewSettings_handlers = useMemo(
    () => viewSettingsHandlers(viewSettings_dispatch),
    [viewSettings_dispatch]
  );

  const {
    confirmation,
    isSolo:
    solo_settings,
    viewSettingsHaveChanged,
    appSettingsChanges,
    settings_temp,
  } = viewSettings_state

  const trueSolo = solo_settings || isSolo ? true : false

  // local statepuse
  const [confirmOn, setConfirmOn] = useState()
  const [updating, setUpdating] = useState()

  const handleSettingsUpdate = () => {
    setUpdating(true)
    const cb = () => {
      setUpdating(false)
      viewSettings_handlers.handleClear_viewSettingsChanged()
    }
    fn_cls.updateSettingsDb(appSettings_fns, cb, settings_temp, paps_state, isGlobal, false, appUser, appSettingsChanges)
  }

  useEffect(() => {
    if (confirmation) {
      setConfirmOn(true)
      const timer = setTimeout(() => setConfirmOn(false), confirmation.success === true ? 2000 : 3000);
      return () => {
        clearTimeout(timer)
      };
    }
    // eslint-disable-next-line
  }, [confirmation]);

  let globalName = _.startCase(appArea)
  const settingsCaption = isGlobal ? globalName + ' Settings' : 'Page Settings'
  let pathCaption = isGlobal ? settingsDocName : trueView

  const closeSettings = () => {
    if (handleCloseGroupItem) { handleCloseGroupItem() }
    if (!handleCloseGroupItem) { navigate(-1) }
  }

  const confirmButton = {
    caption: 'Saved',
    ready: true,
    primary: allowUpdates ? true : false,
    color: iconColorTypes.success,
    keyy: 'ai-save',
    icon: 'check circle outline',
  }

  let saveColor = sandboxOn ? 'blue' : iconColorTypes.save
  if (!allowUpdates) { saveColor = iconColorTypes.deny }

  const saveButton = {
    caption: 'Save Settings',
    ready: viewSettingsHaveChanged,
    onClick: handleSettingsUpdate,
    primary: allowUpdates ? true : false,
    color: updating ? iconColorTypes.fetching : saveColor,
    keyy: 'ai-save',
    icon: updating ? 'cog' : 'save',
    title: 'Save',
    loading: updating,
    nb: updating,
    className: 'blink_me_2'
  }

  /** The buttons for the top header in viewSettings, left or right */
  const rightButtons = () => {
    const b = []
    if (confirmation && confirmation.success && confirmOn) {
      b.push(confirmButton)
    } else {
      b.push(saveButton)
    }
    return b
  }

  const viewSettingsSwiper = () => <ViewSettingsProvider
    viewSettings_state={viewSettings_state}
    viewSettings_handlers={viewSettings_handlers}
  >
    <ViewSettingsSwiper key={uniqueKey('vs', 'vss')} trueSolo={trueSolo} ncProps={ncProps} />
  </ViewSettingsProvider>

  const menuHeader = (iconLeft, iconLeftColor, ocLeft, title, subTitle, labelTitle, rbs) => {
    const x = { iconLeft, iconLeftColor, ocLeft, title, subTitle, labelTitle, rbs, directViewItem }
    return <SettingsMenuSubHeader key={uniqueKey('msh', title)} {...x} />
  }

  let wcn = 'setz vs'
  if (trueSolo) { wcn += ' app' }
  const ccn = 'ct-vs'

  if (directViewItem) {
    return <Wrapper
      header={menuHeader(appIconTypes.arrowLeft, 'blue', null, settingsCaption, pathCaption, (isGlobal ? 'app' : 'view'), rightButtons())}
      content={viewSettingsSwiper()}
      updating={updating}
      css={{ container: wcn, content: ccn }}
    />
  } else {
    if (trueSolo) {
      return <Wrapper
        header={menuHeader(appIconTypes.arrowLeft, 'blue', closeSettings, settingsCaption, pathCaption, (isGlobal ? 'app' : 'view'), rightButtons())}
        content={viewSettingsSwiper()}
        footer={<MenuSettingsClose useDarkMode={useDarkMode} />}
        updating={updating}
        css={{ container: wcn, content: ccn }}
      />
    } else {
      return <Wrapper
        header={menuHeader(appIconTypes.arrowLeft, 'blue', closeSettings, settingsCaption, pathCaption, (isGlobal ? 'app' : 'view'), rightButtons())}
        content={viewSettingsSwiper()}
        updating={updating}
        css={{ container: wcn, content: ccn }}
      />
    }
  }
}

export default ViewSettings